import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import { connectNode } from '../../utils/global'
import { loadLocationWithMessage } from '../../actions/location'

class GetPDF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      pdf: null,
      pdfUrl: '',
      loading: true,
      error: '',
    }
  }

  componentDidMount() {
    this.getData()
  }

  componentWillUnmount() {
    if (this.state.pdfUrl) {
      URL.revokeObjectURL(this.state.pdfUrl)
    }
  }

  base64ToBlob = (base64, contentType = 'application/pdf') => {
    const cleanBase64 = base64.replace(/\s/g, '')
    const byteCharacters = atob(cleanBase64)
    const byteArrays = []

    const sliceSize = 1024
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)
      const byteNumbers = new Array(slice.length)

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      byteArrays.push(new Uint8Array(byteNumbers))
    }

    return new Blob(byteArrays, { type: contentType })
  }

  getData = () => {
    let pid = 0
    if (this.props.authReducer.role == 5) {
      pid = this.props.authReducer.uid
    } else {
      pid = this.props.match.params.pid
      axios({
        method: 'post',
        url: connectNode + 'admin/patient/check_permission_get_data',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8'
        },
        data: {
          pid: this.props.match.params.pid,
          uid: this.props.authReducer.uid,
          user_role: this.props.authReducer.role,
        }
      })
      .then((result2) => {
        if(Array.isArray(result2.data) && result2.data.length) { }
        else {
          // no permission //
          this.props.history.push('/admin/patient_list')
        }
      })
    }

    let path_get_file = ''
    let ftype = ''

    if (this.props.path == 'patient_contract_pdf') {
      path_get_file = 'patient/enroll/get_patient_contract_pdf_no_gen'
    } else if (this.props.path == 'roi_pdf') {
      path_get_file = 'patient/enroll/get_roi_pdf_chk_before_gen'
    } else if (this.props.path == 'roi') {
      path_get_file = 'patient/enroll/get_roi_pdf_version'
    } else if (this.props.match.params.fid > 0) {
      if (this.props.path == 'patient_worksheet_pdf') {
        path_get_file = 'admin/worksheets/worksheet_pdf'
        ftype = 'worksheets'
      } else if (this.props.path == 'worksheet_pdf') {
        path_get_file = 'admin/worksheets/worksheet_pdf'
        ftype = 'admin_worksheets'
      } else {
        path_get_file = 'admin/patient/get_uploaded_file'
      }
    } else if (this.props.path == 'admin_uploaded_file9') {
      path_get_file = 'patient/enroll/get_admin_uploaded_file'
    } else if (this.props.path == 'clinicpolicy') {
      path_get_file = 'admin/patient/consent'
      ftype = 'clinicpolicy'
    } else if (this.props.path == 'patientwaiver') {
      path_get_file = 'admin/patient/consent'
      ftype = 'patientwaiver'
    } else if (this.props.path == 'communication') {
      path_get_file = 'admin/patient/consent'
      ftype = 'communication'
    } else if (this.props.path == 'treatment') {
      path_get_file = 'admin/patient/consent'
      ftype = 'treatment'
    } else if (this.props.path == 'information_sheet') {
      path_get_file = 'admin/patient/consent'
      ftype = 'information_sheet'
    } else if (this.props.path == 'user_guide') {
      path_get_file = 'admin/patient/get_user_guide'
      ftype = 'information_sheet'
    }  else if (this.props.path == 'executive_functioning_coaching') {
      path_get_file = 'admin/patient/consent'
      ftype = 'executive_functioning_coaching'
    }

    console.log(path_get_file)

    axios({
      method: 'post',
      url: connectNode + path_get_file,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data: {
        pid: pid,
        contract_id: this.props.match.params.contract_id,
        fid: this.props.match.params.fid,
        ftype: ftype,
        version: this.props.version,
      },
    })
      .then((result) => {
        const pdfBase64 = result?.data?.data

        if (!pdfBase64) {
          this.setState({
            pdf: result.data,
            loading: false,
            error: '',
          })
          return
        }

        const pdfBlob = this.base64ToBlob(pdfBase64, 'application/pdf')
        const pdfUrl = URL.createObjectURL(pdfBlob)

        this.setState({
          pdf: result.data,
          pdfUrl,
          loading: false,
          error: '',
        })
      })
      .catch((err) => {
        console.error(err)
        this.setState({
          loading: false,
          error: 'Cannot load PDF',
        })
      })
  }

  downloadPDF = () => {
    if (!this.state.pdfUrl) return

    const downloadLink = document.createElement('a')
    const fileName = 'download_' + Date.now() + '.pdf'
    downloadLink.href = this.state.pdfUrl
    downloadLink.download = fileName
    downloadLink.click()
  }

  render() {
    const { pdf, pdfUrl, loading, error } = this.state

    return (
      <div>
        {loading && <div className="loading1">Loading...</div>}

        {!loading && error && (
          <div className="loading1">{error}</div>
        )}

        {!loading && pdf && pdf.data === null && (
          <div className="loading1">The file is not existed</div>
        )}

        {!loading && pdfUrl && (
          <>
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              className="pdf_size_1"
              style={{ width: '100%', height: '800px', border: 'none' }}
            />
            <div className="text_align_right bold">
              <p>&nbsp;</p>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  this.downloadPDF()
                }}
              >
                Download
              </a>
            </div>
          </>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(GetPDF)
